import { render, staticRenderFns } from "./EvaluationProjectView.vue?vue&type=template&id=2aceabcb&scoped=true&"
import script from "./EvaluationProjectView.vue?vue&type=script&lang=ts&"
export * from "./EvaluationProjectView.vue?vue&type=script&lang=ts&"
import style0 from "./EvaluationProjectView.vue?vue&type=style&index=0&id=2aceabcb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aceabcb",
  null
  
)

export default component.exports